import { WhatsappShareButton, WhatsappIcon } from 'react-share';
import { EmailShareButton, EmailIcon } from 'react-share';

export const ShareResultMail = ({ subject, info }) => {
  return (
    <EmailShareButton subject={subject} body={info} url={''}>
      <EmailIcon size={32} round style={{ marginLeft: '4px' }} />
    </EmailShareButton>
  );
};

export const ShareResultWhatsapp = ({ info }) => {
  return (
    <WhatsappShareButton url={'www.pronology.com'} title={info} separator=" ">
      <WhatsappIcon size={32} round style={{ marginLeft: '4px' }} />
    </WhatsappShareButton>
  );
};
